export default [
  {
    path: '/mine/setting',
    name: 'setting',
    meta: {
      index: 12
    },
    component: () => import('@/views/mine/setting.vue')
  }
]